export const nonDigitsOnly = new RegExp(/[^\d]/, 'g');
